import _ from 'lodash';

export default class UserModel{
    constructor(userData){
        this.username = _.get(userData, 'username');
        this.isSalespartnerUser = _.get(userData, 'is_salespartner_user');
        this.salespartner = _.get(userData, 'salespartner');
        this.firstName = _.get(userData, 'first_name');
        this.lastName = _.get(userData, 'last_name');
        this.email = _.get(userData, "email")
    }
}